import type { WorkspaceMode } from "../app/storeTypes.ts";

/**
 * Output-preview workspaces keep camera navigation live, but suppress scene
 * interaction affordances in the viewport. Selection state can still exist in
 * the store; the viewport just stops exposing object picks, gizmos, and
 * selection feedback while the user is framing an output.
 */
export function viewportSupportsSceneInteraction(
  workspaceMode: WorkspaceMode,
): boolean {
  return workspaceMode !== "render" && workspaceMode !== "inking";
}
